import {Injectable} from '@angular/core';
import {IoService} from './io.service';
import {ProductTag} from '../models';

@Injectable()
export class ProductTagService extends IoService {
  protected model = ProductTag;
  protected listUrl = '/producttags/';
}
